import { render, staticRenderFns } from "./TermsAndConditionsPage.fr.vue?vue&type=template&id=1b514256"
import script from "./TermsAndConditionsPage.fr.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPage.fr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports